interface Item {
  name: string;
  internalReference?: string;
  code?: string;
  id?: ID;
}

interface ReturnItem {
  label: string;
  value: Partial<Item> | ID | string;
}

export const createCompanyOption = (item: Partial<Item>): Partial<ReturnItem> => {
  return {
    label: `${item.internalReference} - ${item.name}`,
    value: item,
  };
};

export const createAccountingFirmOption = (item: Partial<Item>): Partial<ReturnItem> => {
  return {
    label: item.name,
    value: item,
  };
};

export const createOptionCounterPart = (item: Partial<Item>): Partial<ReturnItem> => {
  return {
    label: `${item.code} - ${item.name}`,
    value: item.id,
  };
};

export const createOptionLegalStructures = (item: Partial<Item>): Partial<ReturnItem> => {
  return {
    label: `${item.name} (${item.code})`,
    value: item.code,
  };
};
